<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <h3 class="m-0">Relatório de Atendimento</h3>
      </b-card-header>

      <b-card-body>
        <b-form-group label="Modelo do relatório:">
          <b-form-select
            v-model="filtros.modelo"
            :options="modelos"
            size="sm"
            text-field="descricao"
            value-field="id"
          >
          </b-form-select>
        </b-form-group>

        <b-row>
          <b-col cols="6">
            <b-form-group label="Nome do paciente:">
              <b-form-input
                v-model="filtros.nomePaciente"
                size="sm"
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="3">
            <b-form-group label="CPF:">
              <b-form-input
                v-model="filtros.cpf"
                size="sm"
                data-inputmask="'alias': 'cpf'"
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="3">
            <b-form-group label="Cartão do SUS:">
              <b-form-input
                v-model="filtros.cartaoSUS"
                size="sm"
                data-inputmask="'alias': 'cartao_sus'"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="6">
            <b-form-group label="Data de cadastro:">
              <b-row>
                <b-col>
                  <b-form-datepicker
                    v-model="filtros.dataCadastroInicio"
                    placeholder="Data inicial"
                    size="sm"
                  ></b-form-datepicker>
                </b-col>

                <b-col>
                  <b-form-datepicker
                    v-model="filtros.dataCadastroFim"
                    placeholder="Data final"
                    size="sm"
                  ></b-form-datepicker>
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>

          <b-col cols="3">
            <b-form-group label="Cadastrado por:">
              <b-form-select
                v-model="filtros.usuarioCadastro"
                :options="usuariosRecepcao"
                text-field="nome"
                value-field="id"
                size="sm"
              >
              </b-form-select>
            </b-form-group>
          </b-col>

          <b-col cols="3">
            <b-form-group label="Atendido por:">
              <b-form-select
                v-model="filtros.usuarioAtendimento"
                :options="usuariosAtendimento"
                text-field="nome"
                value-field="id"
                size="sm"
              >
              </b-form-select>
              <!-- <muli-select-dropdown
                v-model="filtros.usuarioAtendimento"
                :options="usuariosAtendimento"
                text-field="nome"
                value-field="id"
              >
              </muli-select-dropdown> -->
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="3">
            <b-form-group label="Status:">
              <b-form-select
                v-model="filtros.status"
                :options="status"
                text-field="nome"
                value-field="id"
                size="sm"
              >
              </b-form-select>
            </b-form-group>
          </b-col>

          <b-col cols="3">
            <b-form-group label="Procedência do paciente:">
              <b-form-select
                v-model="filtros.procedencia"
                :options="procedencias"
                text-field="nome"
                value-field="id"
                size="sm"
                multiple
                :select-size="1"
              >
              </b-form-select>
            </b-form-group>
          </b-col>

          <b-col cols="3">
            <b-form-group label="Unidade:">
              <b-form-select
                v-model="filtros.unidade"
                :options="unidades"
                text-field="nome"
                value-field="id"
                size="sm"
              >
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>

      <b-card-footer class="d-flex justify-content-end">
        <b-button variant="primary" @click="gerar"> Gerar Relatório </b-button>
      </b-card-footer>
    </b-card>
  </div>
</template>

<script>
import UsuarioService from "@/core/services/usuario.service";
import AtendimentoService from "@/core/services/atendimento.service";
import Swal from "sweetalert2";
import Inputmask from "@/core/plugins/inputmask";
// import MuliSelectDropdown from "@/core/components/MultiSelectDropdown.vue";

export default {
  name: "RelatorioAtendimento",
  components: {
    // MuliSelectDropdown,
  },
  data() {
    return {
      filtros: {
        modelo: "paciente",
        nomePaciente: "",
        cpf: "",
        cartaoSUS: "",
        dataCadastroInicio: null,
        dataCadastroFim: null,
        usuarioCadastro: null,
        usuarioAtendimento: null,
        status: null,
        procedencia: null,
        unidade: null,
      },
      usuariosRecepcao: [],
      usuariosAtendimento: [],
      status: [],
      modelos: [],
      procedencias: [
        { id: null, nome: "Todos" },
        { id: "A", nome: "Aluno" },
        { id: "P", nome: "Professor" },
        { id: "D", nome: "Diretor" },
        { id: "F", nome: "Funcionário" },
        { id: "E", nome: "Externo" },
      ],
      unidades: [],
    };
  },
  mounted() {
    this.getFiltros();
    this.$nextTick(() => {
      Inputmask().mask(document.querySelectorAll("input[data-inputmask]"));
    });
  },
  methods: {
    async getFiltros() {
      await AtendimentoService.obterFiltrosRelatorios().then((response) => {
        this.modelos = response.data.modelos;
        this.usuariosRecepcao = response.data.usuariosRecepcao;
        this.usuariosAtendimento = response.data.usuariosAtendimento;
        this.status = response.data.status;
        this.unidades = response.data.unidades;
      });
    },

    async gerar() {
      this.showOverlay();

      await AtendimentoService.gerarRelatorioAtendimento({
        ...Object.flatten(Object.filter(this.filtros), "filtros"),
      })
        .then((response) => {
          const contentType = response.headers["content-type"];
          const blob = new Blob([response.data], { type: contentType });
          const fileURL = URL.createObjectURL(blob);

          if (contentType === "application/pdf") {
            // Abre em nova aba se for PDF
            window.open(fileURL, "_blank");
          } else {
            // Força o download se for outro tipo de arquivo
            const link = document.createElement("a");
            link.href = fileURL;

            // Define nome padrão do arquivo
            const disposition = response.headers["content-disposition"];
            const fileNameMatch =
              disposition &&
              disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            const fileName = fileNameMatch
              ? fileNameMatch[1].replace(/['"]/g, "")
              : "arquivo";
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        })
        .finally(() => {
          this.hideOverlay();
        });
    },

    showOverlay() {
      this.$store.dispatch("toggleOverlay", {
        value: true,
        message: "Processando, aguarde...",
      });
    },

    hideOverlay() {
      this.$store.dispatch("toggleOverlay", { value: false });
    },
  },
};
</script>
